module.exports = __webpack_public_path__ + "img/gecInitiative.01a5ba0a.png";